export interface Experiment {
  id: string
  name: string
  description: string
}

export const availableExperiments: Experiment[] = [
  {
    id: 'vue-properties-window',
    name: 'Editor de propiedades (Vue)',
    description:
      'Muestra las propiedades del elemento seleccionado en el editor de plantillas'
  },
  {
    id: 'collection-editor-tweaks',
    name: 'Ajustes al editor de colecciones',
    description:
      'Pequeños ajustes que mejoran la experiencia al crear colecciones'
  }
]
